import script from "./indexOld.vue?vue&type=script&setup=true&lang=js"
export * from "./indexOld.vue?vue&type=script&setup=true&lang=js"

import "./indexOld.vue?vue&type=style&index=0&id=7a5d1622&lang=scss&scoped=true"

import exportComponent from "D:\\workspace\\zh-frontend\\microfront-main\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a5d1622"]])

export default __exports__